module.exports = __webpack_public_path__ + "assets/img/21_1111.729301a6.jpg";